// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ApiList from './utility/api.js'
import dateUtil from './utility/dateUtil.js'
import Toast from './utility/toast.js'
import Ajax from './utility/ajax.js'
import Cache from './utility/cache.js'
import Lodash from 'lodash'
import ElementUI from 'element-ui'
import store from './store/store.js'
import Menu from './utility/menu.js'
import OssImgUrl from './utility/ossImgUrl'

import moment from "moment";
import Ossclient from 'ali-oss'
import * as filters from './utility/filter';
import Utils from './utility/utils'
import fullscreen from 'vue-fullscreen'
import quillEditor from 'vue-quill-editor'
import VueUeditorWrap from 'vue-ueditor-wrap'

import 'element-ui/lib/theme-chalk/index.css'
import 'iview/dist/styles/iview.css'

import './style/element-ui.scss'
import './style/public.scss'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.config.productionTip = false;
Vue.use(quillEditor);
Vue.use(VueUeditorWrap);
Vue.use(ElementUI);
Vue.use(fullscreen);

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

Vue.prototype.$moment = moment;
Vue.prototype.ajax = Ajax;
Vue.prototype.dateUtil = dateUtil;
Vue.prototype.Ossclient = Ossclient;
Vue.prototype.toast = Toast;
Vue.prototype.menu = Menu;
Vue.prototype.Utils = Utils;
Vue.prototype.apis = ApiList;
Vue.prototype.cache = Cache;
Vue.prototype.ossImgUrl = OssImgUrl;
Vue.prototype._ = Lodash;
/* eslint-disable no-new */

Cache.storeMenuItems(Menu.menu);

// 组件引入
import ImageUpload from '@/components/ImageUpload/ImageUpload.vue'

// 全局组件挂载
Vue.component('ImageUpload', ImageUpload);

// 路由导航钩子，beforeEach，在路由进入前调用
router.beforeEach((to, from, next) => {
  //本地没有缓存信息  且不是登录页面 挂钩子去登录页面
  // if (to.name != "login" && !Cache.fetchMenuItems()) {
  //   router.replace("login");
  //   return false
  // }
  // 继续路由导航
  next()
});

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});


window.log = function () {
  // console.log(...arguments);
}




// WEBPACK FOOTER //
// ./src/main.js